"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceWorkerMessageWatcher = void 0;
// import { ServiceWorkerMessageWatcherStyles } from './ServiceWorkerMessageWatcherStyles'
var react_1 = require("react");
var ServiceWorkerMessageWatcher = function (_a) {
    var redirect = _a.redirect;
    (0, react_1.useEffect)(function () {
        if (navigator && navigator.serviceWorker) {
            var eventListener_1 = function (event) {
                var data = event.data;
                if (data.action === 'redirect' && data.url) {
                    redirect(data.url);
                }
            };
            navigator.serviceWorker.addEventListener('message', eventListener_1);
            return function () {
                navigator.serviceWorker.removeEventListener('message', eventListener_1);
            };
        }
        return;
    });
    return null;
};
exports.ServiceWorkerMessageWatcher = ServiceWorkerMessageWatcher;
